// renderers/rowHeaderRenderer.ts

interface RowHeaderRendererContext {
  trackingJobsMap: Record<string, any>;
}

/**
 * Creates a row header renderer that displays tracking job status indicators
 */
export function createRowHeaderRenderer(context: RowHeaderRendererContext) {
  return function handleAfterGetRowHeader(row: number, TH: HTMLTableHeaderCellElement): void {
    if (!context.trackingJobsMap) return;

    //@ts-ignore
    const rowData = this.getDataAtRow(row);
    const shipmentId = rowData[0]; // ID from hidden column

    const trackingJob = shipmentId ? context.trackingJobsMap[shipmentId] : null;

    const hasIssue =
      trackingJob &&
      (trackingJob.status === 'paused' ||
        trackingJob.status === 'deactivated' ||
        trackingJob.status === 'failed' ||
        trackingJob.error ||
        trackingJob.errorMessage ||
        trackingJob.lastError);

    if (!hasIssue) return;

    const iconColor = trackingJob.status === 'failed' || trackingJob.error ? '#ef4444' : '#f59e0b';
    const tooltip =
      trackingJob.status === 'paused'
        ? 'Tracking job is paused'
        : trackingJob.error || trackingJob.errorMessage || trackingJob.lastError
        ? `Error: ${trackingJob.error || trackingJob.errorMessage || trackingJob.lastError}`
        : 'Tracking job deactivated';

    TH.style.cssText = 'padding: 0 !important; text-align: center !important; vertical-align: middle !important;';

    TH.innerHTML = `
        <div style="display: flex; align-items: center; justify-content: center; gap: 2px; height: 100%; width: 100%; padding: 0;">
          <span style="line-height: 1; display: block; position: relative;">${row + 1}
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="${iconColor}" stroke-width="2" 
                 stroke-linecap="round" stroke-linejoin="round" title="${tooltip}"
                 style="flex-shrink: 0; display: block; position: absolute; top: 55%; left: 50%; transform: translate(60%, -55%);">
              <path d="m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3Z"/>
              <line x1="12" x2="12" y1="9" y2="13"/>
              <line x1="12" x2="12.01" y1="17" y2="17"/>
            </svg>
          </span>
        </div>`;
  };
}
